import { baseTheme, createTheme } from "@animech/ui";
import { themeExtensions } from "./extensions";
import { themeOverrides } from "./overrides";

export const theme = createTheme(
	baseTheme, // Change this to whatever theme you want to use
	themeExtensions,
	themeOverrides,
);
